<template>
  <v-card outlined>
    <v-toolbar flat color="primary">
      <v-toolbar-title>Two Factor Authentication</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="10">
          <div v-if="user.two_factor_enabled" class="text--primary">
            You have enabled two factor authentication.
          </div>
          <div v-else class="text--primary">
            You have not enabled two factor authentication.
          </div>
        </v-col>
        <v-col cols="2">
          <ConfirmPassword
            v-if="user.two_factor_enabled"
            @confirmed="disableTwoFactorAuthentication"
          >
            <v-icon small>
              mdi-delete
            </v-icon>
          </ConfirmPassword>

          <ConfirmPassword v-else @confirmed="enableTwoFactorAuthentication">
            <v-icon small>
              mdi-enable
            </v-icon>
          </ConfirmPassword>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <div v-if="user.two_factor_enabled">
        <div v-if="qrCode">
          <div class="mt-4 max-w-xl text-sm text-gray-600">
            <p class="font-semibold">
              Two factor authentication is now enabled. Scan the following QR
              code using your phone's authenticator application.
            </p>
          </div>

          <div class="mt-4">
            {{ qrCode }}
          </div>
        </div>

        <div v-if="recoveryCodes.length > 0">
          <div class="mt-4 max-w-xl text-sm text-gray-600">
            <p class="font-semibold">
              Store these recovery codes in a secure password manager. They can
              be used to recover access to your account if your two factor
              authentication device is lost.
            </p>
          </div>

          <div
            class="grid gap-1 max-w-xl mt-4 px-4 py-4 font-mono text-sm bg-gray-100 rounded-lg"
          >
            <div v-for="(code, index) in recoveryCodes" :key="`code_${index}`">
              {{ code }}
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import ConfirmPassword from '@/Components/Auth/ConfirmPassword'

export default {
   components: {
      ConfirmPassword,
   },

   props: {
      user: {
         type: Object,
         required: true,
      },
   },

   data: () => ({
      enabling: false,
      disabling: false,
      qrCode: null,
      recoveryCodes: [],
   }),

   methods: {
      enableTwoFactorAuthentication () {
         this.enabling = true

         this.$inertia
            .post(
               '/user/two-factor-authentication',
               {},
               {
                  preserveScroll: true,
                  onSuccess: () => {
                     return Promise.all([this.showQrCode(), this.showRecoveryCodes()])
                  }
               }
            )
            .then(() => {
               this.enabling = false
            })
      },

      showQrCode () {
         return axios.get('/user/two-factor-qr-code').then((response) => {
            this.qrCode = response.data.svg
         })
      },

      showRecoveryCodes () {
         return axios.get('/user/two-factor-recovery-codes').then((response) => {
            this.recoveryCodes = response.data
         })
      },

      regenerateRecoveryCodes () {
         axios.post('/user/two-factor-recovery-codes').then((response) => {
            this.showRecoveryCodes()
         })
      },

      disableTwoFactorAuthentication () {
         this.disabling = true

         this.$inertia
            .delete('/user/two-factor-authentication', {
               preserveScroll: true,
            })
            .then(() => {
               this.disabling = false
            })
      },
   },
}
</script>
